import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import { useFormContext } from "react-hook-form";
import type { AuthProvider } from "@/app/oauth/types";

export const IdField = () => {
  const form = useFormContext<AuthProvider>();

  return (
    <FormField
      control={form.control}
      name="id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>ID</FormLabel>
          <FormControl>
            <Input
              {...field}
              onChange={(e) => {
                const value = e.target.value
                  .toLowerCase()
                  .replace(/[^a-z0-9_-]/g, "");
                field.onChange(value);
              }}
              placeholder="my-oauth-provider"
            />
          </FormControl>
          <FormMessage />
          <FormDescription>
            Unique identifier limited to lowercase, numbers, underscores, and
            hyphens.
          </FormDescription>
        </FormItem>
      )}
    />
  );
};
